import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import React from 'react';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AlertDialogSlide({ visible, onClose, height, width, maxWidth, children, ...rest }) {
  // Avoid spreading unknown props (visible, onEnter, etc.) onto the MUI Dialog DOM element
  const { onEnter, ...safeRest } = rest;
  return (
    <div>
      <Dialog
        open={visible}
        TransitionComponent={Transition}
        keepMounted
        PaperProps={{
          style: {
            minHeight: height || null,
            minWidth: width || null,
          },
        }}
        onClose={onClose}
        fullWidth={true}
        maxWidth={maxWidth || 'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        {...(onEnter ? { TransitionProps: { onEnter } } : {})}>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </div>
  );
}

AlertDialogSlide.propTypes = {
  children: PropTypes.any,
  height: PropTypes.any,
  maxWidth: PropTypes.string,
  onClose: PropTypes.any,
  visible: PropTypes.any,
  width: PropTypes.any,
};

export default AlertDialogSlide;
